import { render } from "./file_input.vue?vue&type=template&id=21c3c544"
import script from "./file_input.vue?vue&type=script&lang=js"
export * from "./file_input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__